import * as Config from '../config';
import React from 'react';
import PropTypes from 'prop-types';
import * as Dialog from '@radix-ui/react-dialog';
import './library/modal/Modal.css';

const srOnly = {
  position: 'absolute', width: 1, height: 1, padding: 0, margin: -1,
  overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap', border: 0
};

// Catch Global Error
function ErrorModalV2({ error }) {
  console.log('Crash Before Loading', error);

  const report = () => {
    // Report and send to a custom outside Error Management
    (window.errorLogCrash) && window.errorLogCrash(error);
    window.location.reload();
  }

  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={`underlay has-entered ${Config.API_NAME}`}
          style={{
            width: `100%`, height: window.innerHeight + ((1 - window[`window_zoom`]) * 1000),
            position: `relative`,
            background: `rgba(36, 36, 36, 0.8)`,
            display: `flex`, alignItems: `center`, justifyContent: `center`
          }}
        >
          <Dialog.Content
            aria-describedby={undefined}
            onEscapeKeyDown={(e) => e.preventDefault()}
            onPointerDownOutside={(e) => e.preventDefault()}
            onInteractOutside={(e) => e.preventDefault()}
            asChild
          >
            <div tabIndex={0} className={`modal bpc flexColumn modal--animated has-entered`} style={{ textAlign: `center` }}>
              <Dialog.Title style={srOnly}>ErrorModal</Dialog.Title>
              <div className="modal-body">
                <div className={`flexColumn modal-form-container`}>
                  <div className={`flexColumn cta`} style={{marginTop: `-40%`, marginLeft: `-10%`}}>
                    <div className={`flexColumn modalV2`} style={{}}>
                      <div className={`flexColumn body`} style={{gap: 26}}>
                        <div className={`title`}>Session Timeout</div>
                        <div className={`description`}> Make sure only one session is open and try reloading the page.</div>
                        <div className={`flexRow group-cta`} style={{}}>
                          <div className={`cta primary`} onClick={report}>Reload</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

ErrorModalV2.propTypes = {
  error: PropTypes.any
}

export default ErrorModalV2;
